import HookForm from "../../../../components/HookForm/HookForm";
import DocsInputNew from "../../../../components/Inputs/DocsInput/DocsInputNew";

const EditCarGosNumber = ({ onSubmit, loading, backHandler }) => {
  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            label: 'ÐÐ ÐÐ',
            name: 'grnz',
            id: 'grnz',
            rules: {
              required: true,
            },
          },
          {
            label: 'Ð¢ÐµÑÐ¿Ð°ÑÐ¿Ð¾ÑÑ',
            name: 'texNumber',
            id: 'texNumber',
            rules: {
              required: true,
            },
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default EditCarGosNumber;
